import { Button } from '@/components/common';
import { Routes } from '@/constants/routes';
import { Spinner } from '@/components/common/Spinner';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { Roles } from '@/constants/roles';
import { AuthUserResponse, useGetUserQuery } from '@/api';
import { useLocalStorage } from 'usehooks-ts';
import { USER_DETAILS } from '@/constants/storage';
import { useRouter } from 'next/router';
import styles from './Steps.module.css';
import completed from '../../../../../public/animations/payment-completed.json';

export const Pending = () => {
  const { isDesktop } = useMediaQuery();
  const router = useRouter();
  const [, setUser] = useLocalStorage<null | AuthUserResponse>(USER_DETAILS, {});

  const { refetch: getUser, isFetching: isGetUserLoading } = useGetUserQuery({
    onSuccess(data) {
      if (router.pathname === '/sign-up') {
        return router.push(`/${Roles.BUSINESS}${Routes.WELCOME}`);
      }
      setUser(data);
      return router.push(`/${Roles.BUSINESS}${Routes.WELCOME}`);
    },
    enabled: false,
  });

  return (
    <div className={styles.pendingWrapper}>
      <Spinner animationData={completed} side={isDesktop ? 64 : 60} />

      <h3 className={styles.pendingTitle}>Verification Pending</h3>

      <p className={styles.pendingDescription}>
        We are currently verifying your submissions and will get back to you within 1-2 working days. If your KYC fails,
        you will be contacted and asked to re-verify.
      </p>

      <Button fluid className={styles.pendingButton} onPress={() => getUser()} loading={isGetUserLoading}>
        Got it
      </Button>
    </div>
  );
};
